


































import { listFactory } from '@/main/pages';

import { isMultipleWorkshopSelected, getSearchButtonLabel, handleMultiWorkshopFilter, validateDateFields, getCurrentLanguageId } from '@/main/utils/commonFunctions';

import dayjs from 'dayjs';

import { MAX_DAYS, MIN_DAYS, NAME } from './constants';
import { store } from './store/list';
import { apiProvider } from './api';


export default listFactory(NAME, store).extend({
	data() {
		return {
			validateMessage: '',
			parameters: '' as string,
		};
	},
	computed: {
		isMultipleWorkshopSelected(): boolean {
			return isMultipleWorkshopSelected(this.WorkshopIds);
		},
		searchButtonLabelKey(): string {
			return getSearchButtonLabel(this.WorkshopIds);
		},
	},
	methods: {
		// eslint-disable-next-line consistent-return
		dateValidation() {
			if (this.DateFrom && this.DateTo) {
				const fromDate = new Date(this.DateFrom);
				const toDate = new Date(this.DateTo);
				if (fromDate > toDate) {
					this.showErrorAlert({
						message: this.LocalizeChyboveHlasky('GREATER_DATE_VALIDATION'),
						options: { type: 'error' },
						localizeMessage: false,
					});
					this.DateTo = null;
					return false;
				}
			} else {
				return false;
			}
		},
		async filterClick() {
			if (!validateDateFields(this, 'DateFrom', 'DateTo')) {
				return;
			}
			await handleMultiWorkshopFilter(
				this,
				NAME,
				this.WorkshopIds,
				(columnsSeq) => ({
					WorkshopIds: this.WorkshopIds,
					DateFrom: this.DateFrom,
					DateTo: this.DateTo,
					LoggedUserId: this.LoggedUserId,
					ColumnSequence: columnsSeq.join(','),
					LanguageId: getCurrentLanguageId(this.loggedUser.UzivatelData.LanguageId),
				}),
			);
		},
		isValidDateRange(): boolean {
			if (this.DateFrom && this.DateTo) {
				const daysDifferance = dayjs(new Date(this.DateTo)?.toDateString()).diff(dayjs(new Date(this.DateFrom)?.toDateString()), 'days');
				if (daysDifferance < MIN_DAYS) {
					this.showErrorAlert({ message: this.LocalizePopisPoli('GREATER_DATE_VALIDATION') });
					this.DateFrom = null;
					this.DateTo = null;
					return false;
				} if (daysDifferance > MAX_DAYS) {
					this.showErrorAlert({ message: this.LocalizePopisPoli('CR_MAX_DAYS_VALIDATION').replace('<DAYS>', `${MAX_DAYS}`) });
					this.DateFrom = null;
					this.DateTo = null;
					return false;
				}
				return true;
			}
			this.showErrorAlert({ message: this.LocalizePopisPoli('CR_DATE_VALIDATION') });
			return false;
		},
		GetParameters(WorkshopIds: any, fromDate: any, toDate: any) {
			const dateFromStr = fromDate ? `DateFrom=${new Date(fromDate).toISOString()}` : '';
			const dateToStr = toDate ? `DateTo=${new Date(toDate).toISOString()}` : '';
			const workshopIdStr = WorkshopIds.length > 0
				? WorkshopIds.map((id: any) => `&WorkshopIds=${id}`).join('')
				: '';
			const loggedUser = this.filter.LoggedUserId != null ? `LoggedUserId=${this.filter.LoggedUserId}` : '';
			const languageId = `LanguageId=${getCurrentLanguageId(this.loggedUser.UzivatelData.LanguageId)}`;
			return [dateFromStr, dateToStr, workshopIdStr, loggedUser, languageId].filter(Boolean).join('&');
		},
		async exportFun() {
			try {
				if (this.filter.DateFrom == null || this.filter.DateTo == null) {
					return;
				}
				if (this.filter.WorkshopIds == null || this.filter.WorkshopIds.length === 0) {
					this.showErrorAlert({ message: this.LocalizePopisPoli('DEALER_CODE_NOT_NULL') });
					return;
				}
				const columnsSeq = this.table.columns.filter(x => x.isVisible === true).map(x => x.columnName);
				if (this.isMultipleWorkshopSelected) {
					this.showErrorAlert({
						message: this.LocalizeChyboveHlasky('MultiWorkshopExportDisabled'),
					});
				} else {
					this.startLoading();
					const urlParameters: string = this.GetParameters(this.WorkshopIds, this.DateFrom, this.DateTo);
					await apiProvider.GetAdvancePayment(urlParameters, columnsSeq);
				}
			} finally {
				this.endLoading();
			}
		},
	},

	mounted() {
		const element = document.getElementsByClassName('el-main');
		if (element.length !== 0) element[0].classList.remove('d-flex');
	},
});
